import MHeader from "./MHeader";
import MNotificationDrawer from "./drawer/MNotificationDrawer";
import UserDrawer from "./drawer/UserDrawer";
import ContactTagsDrawer from "./drawer/ContactTagsDrawer";
import ListsDrawer from "./drawer/ListsDrawer";
import BrandsListDrawer from "./drawer/BrandsListDrawer";
import ContactInfoDrawer from "./drawer/ContactInfoDrawer";

export const DashboardComponents = {
    MHeader,
    MNotificationDrawer,
    UserDrawer,
    ContactTagsDrawer,
    ListsDrawer,
    BrandsListDrawer,
    ContactInfoDrawer,
}